import { Injectable } from '@angular/core';

import { renderEnvironment } from 'environments/environment';


@Injectable()
export class EcommerceUrlResolverService {

  private readonly baseEcommerceApiUrl = renderEnvironment.apiEcommerceBaseUrl;

  public resolveEcommerceAPI(version: number, ...params: string[]): string {
    const baseEcommerceApiUrl = this.getBaseUrlEcommerceApi(version);
    const url = this.getPath(params);

    return baseEcommerceApiUrl.concat(url);
  }

  private getBaseUrlEcommerceApi(version: number): string {
    return `${this.baseEcommerceApiUrl}/${version}/`;
  }

  private getPath(params: string[]): string {
    if (!params.length) {
      throw new Error('wrong arguments to setUrls');
    }

    let url = params.slice(0, 1)[0];
    params.splice(1).forEach(
      (param: string) => {
        url = url.replace(/%s/, param);
      }
    );

    return url;
  }

}
